import { Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { marked } from 'marked';

@Pipe({ name: 'markdown' })
export class MarkdownPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(value?: string): SafeHtml {
    if (!value) { return ''; }
    const normalized = this.normalizePlainText(value);
    const html = marked.parse(normalized, {
      async: false,
      gfm: true,
      breaks: true
    }) as string;
    const safe = this.sanitizer.sanitize(SecurityContext.HTML, html) ?? '';
    return this.sanitizer.bypassSecurityTrustHtml(safe);
  }

  private normalizePlainText(value: string): string {
    const input = (value ?? '').trim();
    if (!input) { return ''; }

    const hasMarkdownSyntax = /(^\s*[-*+]\s)|(^\s*\d+\.\s)|[`*_#>|]/m.test(input);
    if (hasMarkdownSyntax || input.includes('\n')) { return input; }

    return input.replace(
      /([.!?])\s+(?=[A-ZÁÀÂÃÉÈÊÍÏÓÔÕÖÚÇ])/gu,
      '$1\n\n'
    );
  }
}
